const deleteEquipments = {
  toastr: 'Equipamentos deletados',
  toastr1: 'Equipamentos deletados com sucesso'
};

export default deleteEquipments;
